module.exports = __webpack_public_path__ + "img/tr.121e8386.svg";